import {
  personalizedSlipBlockSchema,
  personalizedSlipSchema,
  personalizedSlipSettingsSchema,
} from "@redotech/redo-fulfillment-operations-common/personalized-slip/personalized-slip-definition";
import * as z from "zod";

export const createPersonalizedSlipTemplate = {
  name: "createPersonalizedSlipTemplate" as const,
  input: z.object({
    teamId: z.string(),
    name: z.string(),
    copyFromTemplateId: z.string().optional(),
    /** Initial template content from pre-built templates */
    initialTemplate: z
      .object({
        blocks: z.array(personalizedSlipBlockSchema),
        globalSettings: personalizedSlipSettingsSchema,
      })
      .optional(),
  }),
  output: personalizedSlipSchema,
};
